/** Extract an 11-char YouTube video ID from a URL or raw ID. */
export function parseYoutubeId(input) {
  if (!input) return '';
  const s = String(input).trim();
  if (/^[\w-]{11}$/.test(s)) return s;
  try {
    const u = new URL(s.startsWith('http') ? s : `https://${s}`);
    if (u.hostname.includes('youtu.be')) {
      return u.pathname.replace(/^\//, '').split('/')[0].slice(0, 11);
    }
    const v = u.searchParams.get('v');
    if (v) return v.slice(0, 11);
    const m = u.pathname.match(/\/(?:embed|shorts|live|v)\/([\w-]{11})/);
    if (m) return m[1];
  } catch {
    /* ignore */
  }
  return '';
}

export function youtubeWatchUrl(idOrUrl) {
  const id = parseYoutubeId(idOrUrl);
  if (id) return `https://www.youtube.com/watch?v=${id}`;
  return String(idOrUrl || '').trim();
}

export function youtubeThumb(idOrUrl, size = 'maxresdefault') {
  const id = parseYoutubeId(idOrUrl);
  return id ? `https://img.youtube.com/vi/${id}/${size}.jpg` : '';
}
